/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Subtitle,
    SubtitleFromJSON,
    SubtitleFromJSONTyped,
    SubtitleToJSON,
} from './';

/**
 * 
 * @export
 * @interface EditorSubtitlePartialUpdate
 */
export interface EditorSubtitlePartialUpdate {
    /**
     * 
     * @type {number}
     * @memberof EditorSubtitlePartialUpdate
     */
    file?: number;
    /**
     * 
     * @type {number}
     * @memberof EditorSubtitlePartialUpdate
     */
    parent?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorSubtitlePartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorSubtitlePartialUpdate
     */
    format?: string;
    /**
     * 
     * @type {Subtitle}
     * @memberof EditorSubtitlePartialUpdate
     */
    subtitle?: Subtitle;
}

export function EditorSubtitlePartialUpdateFromJSON(json: any): EditorSubtitlePartialUpdate {
    return EditorSubtitlePartialUpdateFromJSONTyped(json, false);
}

export function EditorSubtitlePartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorSubtitlePartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : json['file'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'subtitle': !exists(json, 'subtitle') ? undefined : SubtitleFromJSON(json['subtitle']),
    };
}

export function EditorSubtitlePartialUpdateToJSON(value?: EditorSubtitlePartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
        'parent': value.parent,
        'name': value.name,
        'format': value.format,
        'subtitle': SubtitleToJSON(value.subtitle),
    };
}


